<div class="dialogue-content">
  <div class="mat-dialogue-header">
    <h4 class="mat-dialog-title previewHeading" id="modal-basic-title">{{LabelConstant.addSessionSuccess}}</h4>
    <button type="button" class="btn-close" aria-label="Close" [mat-dialog-close]="false"></button>
  </div>
  <mat-dialog-content class="">
    <p class="confirmation">{{LabelConstant.sessionAddedSuccesfully}}</p>
    <img [src]="customerData.images" (error)="handleImageError()" class="profile-pic-delete" alt="" />
    <p class="name WrapData">{{customerData.firstName}} {{customerData.lastName}}</p>
  </mat-dialog-content>
  <div mat-dialog-actions class="dialog-actions dialogue-footer text-center mb-3">
    <button class="btn btn-primary" [mat-dialog-close]="true">{{LabelConstant.ok}}</button>
  </div>
</div>